import { ComponentPropsWithoutRef } from 'react';

function AnonEyeIcon(props: ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg
      data-testid="anonymous-icon"
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="12"
      {...props}
    >
      <g fill={props.fill ?? '#7FABEC'}>
        <path d="M14.699 6.454a11.131 11.131 0 0 1-2.075 2.585l-1.006-1.005a9.546 9.546 0 0 0 1.627-1.932c-.664-1.01-2.676-3.641-5.733-3.564-.427.011-.828.078-1.21.18L5.176 1.591a6.666 6.666 0 0 1 2.3-.478c4.257-.133 6.768 3.838 7.223 4.63.125.22.125.49 0 .71ZM9.035 9.481l1.125 1.126a6.662 6.662 0 0 1-2.474.48c-4.177 0-6.6-3.852-7.048-4.633a.711.711 0 0 1 0-.71c.295-.514.99-1.596 2.075-2.586l1.005 1.006a9.57 9.57 0 0 0-1.626 1.932C2.756 7.107 4.758 9.73 7.825 9.66c.427-.01.829-.078 1.21-.179ZM7.668 7.168A1.07 1.07 0 0 1 6.6 6.098c0-.017.008-.033.009-.052L7.722 7.16c-.019 0-.035.008-.054.008Z" />
        <path d="M3.62 1.11a.713.713 0 0 0-1.008 1.008l2.865 2.797a2.461 2.461 0 0 0-.303 1.184 2.497 2.497 0 0 0 2.494 2.494c.42 0 .823-.105 1.185-.302l3.001 3a.709.709 0 0 0 1.008 0 .712.712 0 0 0 0-1.007L3.62 1.11Z" />
      </g>
    </svg>
  );
}

export default AnonEyeIcon;
